// Dubai guide: how to become a personal trainer in the UAE. Also a trainer
// recruitment funnel. Keep regulatory statements general (rules change).
const content = {
    slug: 'become-a-personal-trainer-uae',
    title: 'How to Become a Personal Trainer in the UAE | Steps and Costs',
    description: 'How to become a personal trainer in the UAE: recognised qualifications, REPs UAE registration, working in a gym vs freelance, and finding clients.',
    eyebrow: 'UAE · Trainer careers',
    h1: 'How to Become a Personal Trainer in the UAE',
    lead: 'The UAE has a large, fitness-focused population and steady demand for good trainers. Here are the steps to qualify, register and start working - in a gym or as a freelancer.',
    datePublished: '2026-10-03',
    image: 'personal-trainer/generated/team-of-personal-trainer-vector.jpg',
    imageAlt: 'Illustration of a team of personal trainers',
    summary: {
        title: 'The path in brief',
        items: [
            'Get a recognised personal training qualification.',
            'Hold valid first aid and CPR certification.',
            'Register with REPs UAE, the national register of exercise professionals.',
            'Work for a gym, or get the permit or licence needed to work freelance.',
        ],
    },
    sections: [
        {
            title: 'Step 1: Qualify',
            paragraphs: [
                'Choose a personal training qualification that REPs UAE recognises - internationally known certifications are widely accepted. Expect a mix of anatomy, programme design, nutrition basics and practical assessment. Many trainers start with a general qualification and add specialisms later: pre and postnatal, older adults, strength and conditioning.',
            ],
        },
        {
            title: 'Step 2: Register with REPs UAE',
            paragraphs: [
                'REPs UAE keeps the national register of exercise professionals. Gyms commonly require registration, and clients increasingly ask for it. You will need your qualification and first aid certificate, and you renew periodically with continuing education.',
            ],
        },
        {
            title: 'Step 3: Gym or freelance',
            cards: [
                { title: 'Gym-employed', body: 'A visa and salary, often plus commission on PT sessions. Good for building experience and a client base.' },
                { title: 'Freelance', body: 'Higher earnings per session and your own schedule, but you need the right permit or licence, your own insurance and your own clients.' },
            ],
        },
        {
            title: 'Step 4: Find clients',
            paragraphs: [
                'Word of mouth in residential communities works well - many Dubai clients train in their building gym or at home. Platforms like StringsSG bring clients to you and handle scheduling and payment, so you can focus on coaching.',
            ],
        },
    ],
    faqs: [
        {
            question: 'Do I need REPs UAE registration to work as a trainer?',
            answer: 'Most gyms require it and it is the recognised standard. Check current requirements with REPs UAE and any employer.',
        },
        {
            question: 'Can I work as a freelance trainer in Dubai?',
            answer: 'Yes, with the appropriate freelance permit or trade licence. The options and costs vary - check the current routes with the relevant authority or free zone.',
        },
    ],
    cta: {
        title: 'Join our founding trainer team in Dubai',
        body: 'Certified and registered? We bring the clients, you bring the coaching.',
        href: '/service-provider-signup',
        label: 'Apply as a trainer',
    },
}

export default content
